module.exports = __webpack_public_path__ + "img/filter.37e525da.svg";